<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="$props.name"
    :rules="$props.rules"
    class="base-checkbox"
    tag="div"
  >
    <b-form-checkbox
      v-model="modelValue"
      v-bind="$attrs"
      v-on="$listeners"
      :id="id"
      :class="{ 'is-invalid': !!errors.length }"
      :value="$props.checkedValue"
    >
      <slot>
        <span v-if="!!$props.label" class="ml-2">{{ $props.label }}</span>
      </slot>
    </b-form-checkbox>

    <div v-if="!!errors.length" class="invalid-feedback">{{ errors[0] }}</div>
  </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { uniqueId, isArray } from 'lodash-es'
import { ValidationProvider } from 'vee-validate'

export default defineComponent({
  name: 'BaseCheckbox',
  inheritAttrs: false,
  components: {
    ValidationProvider
  },
  props: {
    name: String,
    label: String,
    rules: String,
    value: [String, Number, Boolean, Array],
    checkedValue: [String, Number, Boolean],
    uncheckedValue: [String, Number, Boolean]
  },
  emits: ['input'],
  setup(props, { emit }) {
    const id = computed(() => `id_${uniqueId('base-checkbox-')}`)

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => {
        if (isArray(props.value)) {
          emit('input', !!newValue.length ? newValue : [])
        } else {
          emit('input', newValue || props.uncheckedValue)
        }
      }
    })

    return {
      id,

      modelValue
    }
  }
})
</script>

<style scoped>
.base-checkbox >>> .custom-control {
  line-height: 1;
}

.base-checkbox >>> .custom-checkbox label {
  min-width: 20px;
  min-height: 20px;
  padding-left: 20px;
  margin-bottom: 0;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}
</style>
